import { padding } from '@/utils/string';
import { mixins } from 'vue-class-component';

export function parseDate(input: any) {
  if (input == null) {
    return null;
  }
  const date = new Date(input);
  if (isNaN(date.getTime())) {
    return null;
  }
  return date;
}

export function getDate(date: Date) {
  if (!date) {
    return null;
  }
  return `${date.getFullYear()}-${padding(date.getMonth() + 1, 2)}-${padding(date.getDate(), 2)}`;
}

export function getTime(date: Date) {
  if (!date) {
    return null;
  }
  return `${padding(date.getHours(), 2)}:${padding(date.getMinutes(), 2)}`;
}

export function isLeapYear(year: number) {
  return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
}

export function getDaysInMonth(year: number, month: number) {
  return [31, (isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
}

export function addMonth(date: Date, n: number) {
  const result = new Date(date);
  const day = result.getDate();
  result.setDate(1);
  result.setMonth(result.getMonth() + n);
  result.setDate(Math.min(day, getDaysInMonth(result.getFullYear(), result.getMonth())));
  return result;
}

export function addDay(date: Date, n: number) {
  return new Date(date.getTime() + n * 24 * 3600 * 1000);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/date.ts